module.exports = __webpack_public_path__ + "static/img/samajuri (38).c272732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (38).jpg
// module id = pCsC
// module chunks = 0